export enum StoragePageEnum {
    FormAnotacao = 'FormAnotacao',
    FormCondutor = 'FormCondutor',
    FormContrato = 'FormContrato',
    FormDio = 'FormDio',
    FormBeneficiaria = 'FormBeneficiaria',
    ExecutorLocal = 'ExecutorLocal'
}